import { createStyles, Theme } from '@material-ui/core';
import get from 'lodash/get';
import { styleFormIoComponent } from '#web-components/styles/form';
import { COMPONENT_CLASSES } from '../../constants';

const fieldsetSelector = `.${COMPONENT_CLASSES.fieldset}`;

export const createFieldSetStyles = (theme: Theme) => ({
  [fieldsetSelector]: {
    ...get(styleFormIoComponent(COMPONENT_CLASSES.fieldset, theme), fieldsetSelector, {}),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    '&.formio-hidden': {
      padding: 0,
    },

    '& .formio-component': {
      marginBottom: theme.spacing(6),
    },
    '& .formio-component:last-child': {
      marginBottom: 0,
    },
    '& legend': {
      ...theme.typography.h5,
      marginBottom: 0,
      display: 'flex',
      wordWrap: 'break-word',
    },
    '& .formio-clickable': {
      width: 'fit-content',
      '& img': {
        borderRadius: theme.borders.radius1,
        marginLeft: theme.spacing(2),
        width: theme.spacing(4),
        height: theme.spacing(4),
      },
      '&:hover img': {
        background: theme.colors.controls.buttonIcon.hovered.hoverArea,
        boxShadow: `0px 0px 0px ${theme.spacing(1)}px ${theme.colors.controls.buttonIcon.hovered.hoverArea}`,
      },
    },
    '& .non-collapsed': {
      marginBottom: theme.spacing(6),
    },
    '& .non-collapsed img': {
      transform: 'rotate(180deg)',
    },
  },
}) as Record<string, unknown>;

export default (theme: Theme) => createStyles({
  '@global': createFieldSetStyles(theme),
});
